import GTM from '@/utils/Controllers/GTM/Constants';
import { push } from '@/utils/Controllers/GTM/Utils';

export const pushGtmServiceLocatorNearMe = () => {
  push({
    event: GTM.EVENT.SERVICE_LOCATOR,
    eventCategory: GTM.EVENT.CATEGORY.AFTER_SALES,
    eventAction: GTM.EVENT.ACTION.SERVICE_LOCATOR,
    eventLabel: GTM.EVENT.LABEL.SERVICE_LOCATOR.NEAR_ME,
  });
};

export const pushGtmServiceLocatorSearch = () => {
  push({
    event: GTM.EVENT.SERVICE_LOCATOR,
    eventCategory: GTM.EVENT.CATEGORY.AFTER_SALES,
    eventAction: GTM.EVENT.ACTION.SERVICE_LOCATOR,
    eventLabel: GTM.EVENT.LABEL.SERVICE_LOCATOR.SEARCH,
  });
};

export const pushGtmServiceLocatorVisitWebsite = () => {
  push({
    event: GTM.EVENT.SERVICE_LOCATOR,
    eventCategory: GTM.EVENT.CATEGORY.AFTER_SALES,
    eventAction: GTM.EVENT.ACTION.SERVICE_LOCATOR,
    eventLabel: GTM.EVENT.LABEL.SERVICE_LOCATOR.VISIT_WEBSITE,
  });
};

export const pushGtmServiceLocatorGoogleMaps = () => {
  push({
    event: GTM.EVENT.SERVICE_LOCATOR,
    eventCategory: GTM.EVENT.CATEGORY.AFTER_SALES,
    eventAction: GTM.EVENT.ACTION.SERVICE_LOCATOR,
    eventLabel: GTM.EVENT.LABEL.SERVICE_LOCATOR.GOOGLE_MAPS,
  });
};
